import { Helmet } from "react-helmet"
import { newsApiParams } from "../../../config";
import { getLanguageByBasename } from '../../helpers/routingHelpers';

const RssFeedLink = () => {
  const language = getLanguageByBasename().key;

  if (language !== 'en-US') return null;

  return (
    <Helmet>
      <link rel="alternate" type="application/rss+xml" href={`${newsApiParams.baseUrl}/${language}/rss`}/>
    </Helmet>
  )
}

export default RssFeedLink;
